import isNumber from './is-number';

var isNegative = function (num) {
  return isNumber(num) && num < 0;
};

export default isNegative;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-negative.js
// module id = 63
// module chunks = 0